$(function() {
  var $form = $('#contact-form');

  if($form.length > 0) {
    $form.on('submit', function(event) {
      event.preventDefault();

      grecaptcha.ready(function() {
        grecaptcha.execute('6LcTNcEUAAAAAPhK-tPYjJ0L5Zhf89S22KBjXoYF', {action: 'contactform'}).then(function(token) {
          var data = {
            response: token
          };

          $form.find('input, textarea').each(function(index, element) {
            var $element = $(element);
    
            if($element.attr('type') == 'radio') {
              if($element.attr('checked')) {
                data[$element.attr('id')] = true;
              }
            } else if($element.attr('type') == 'checkbox' && $element[0].checked) {
              data[$element.attr('id')] = true;
            } else if($element.val().length > 0) {
              data[$element.attr('id')] = $element.val();
            }
          });
    
          $.post('mailer.php', data, function(response) {
            console.log(response);
            if(data.hasOwnProperty('maintenance')) {
              gtag('event', 'submit', {
                'event_category': 'Contact form',
                'event_label': 'Maintenance',
                'value': 1000
              });
            } else {
              gtag('event', 'submit', {
                'event_category': 'Contact form',
                'event_label': 'One-time',
                'value': 500
              });
            }
          });
        });
      });
    });
  }
});